<style scoped>
span.circle {
  display: inline;
  margin-right: 10px;
  padding: 0 3px 0 3px;
}
</style>

<template>
  <span>
    <!-- prettier-ignore -->
    <span :class="[statusColor]" class="circle white--text elevation-2">{{ quantity }}</span>
  </span>
</template>

<script>
export default {
  props: {
    deliveryStatus: String,
    rejectionStatus: String,
    quantity: Number
  },
  computed: {
    status() {
      return this.rejectionStatus === "C" ? "X" : this.deliveryStatus;
    },
    statusColor() {
      switch (this.status) {
        case "X":
          return "blue-grey";
        case "C":
          return "green";
        case "B":
          return "yellow";
        default:
          return "light-blue";
      }
    }
  }
};
</script>
